/*
 * Copyright (C) 2025 SimpliCity Digital Inc - All Rights Reserved
 */

import { Link } from "react-router-dom";
import { useMedia } from "react-use";
import { Button } from "@mui/material";
import { ReactComponent as CityLogo } from "cms/assets/images/city-logo.svg";
import { QuickSearch } from "components/search";
import { AccountButtons } from "./account-buttons";
import { ReactComponent as MenuIcon } from "cms/assets/icons/bars.svg";

const HeaderTopBar = (props) => {

    const { toggleMobile } = props;
    const isDesktop = useMedia("screen and (min-width: 835px)");

    return (
        <div className='header-top-bar'>
            <div className='header-top-bar-content services-header'>
                <Link to='/' className='city-logo'>
                    <CityLogo alt='city-logo' />
                </Link>
                <div className='services-header-content'>
                    <QuickSearch />
                    {isDesktop && <AccountButtons />}
                    {!isDesktop &&
                        <div className='header-menu-mobile'>
                            <Button className='mobile-menu-button' onClick={toggleMobile} variant='standard'>
                                <MenuIcon alt='menu-icon' />
                                Menu
                            </Button>
                        </div>
                    }
                </div>
            </div>
        </div>
    );
};

export { HeaderTopBar };
